import LearnMoreSection from './LearnMoreSection';

export default LearnMoreSection;
